import { isTV } from "../utils/platform";
import { UserSubscriptionStatus } from "@onmo/graphql/graphql";

export const setActivationCode = (code: string) => {
  return localStorage.setItem("activationCode", code);
};

export const getActivationCode = () => {
  return localStorage.getItem("activationCode") || "";
};

export const clearActivationCode = () => {
  return localStorage.removeItem("activationCode");
};

export const isShowActivation = () => {
  const activationCode = getActivationCode();
  return activationCode && activationCode !== "skipped" && !isTV;
};

export const isShowPaywall = (status?: UserSubscriptionStatus) => {
  const activationCode = getActivationCode();

  return (
    !activationCode && !isTV && status === UserSubscriptionStatus.NotSubscribed
  );
};

export const setSkippedActivationCode = () => {
  return localStorage.setItem("activationCode", "skipped");
};
